module.exports = __webpack_public_path__ + "static/media/no-image-14597.a48f6d51.svg";